import { BillingPeriod } from '@/components/ReservationContext'
import { Tabs, TabsList, TabsTrigger } from '@/shared/ui/tabs'

import { PeriodDatePicker } from './PeriodDatePicker'

interface BillingControlsProps {
    selectedDate: Date
    selectedPeriod: BillingPeriod
    onDateChange: (date: Date | undefined) => void
    onPeriodChange: (period: string) => void
}

export function BillingControls({ selectedDate, selectedPeriod, onDateChange, onPeriodChange }: BillingControlsProps) {
    return (
        <div className='flex items-center gap-4'>
            <PeriodDatePicker date={selectedDate} period={selectedPeriod} onSelect={onDateChange} />
            <Tabs value={selectedPeriod} onValueChange={onPeriodChange}>
                <TabsList>
                    <TabsTrigger value='daily'>Diario</TabsTrigger>
                    <TabsTrigger value='weekly'>Semanal</TabsTrigger>
                    <TabsTrigger value='monthly'>Mensual</TabsTrigger>
                </TabsList>
            </Tabs>
        </div>
    )
}
